module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-08-24 at 14.52.45.8e457635.png";